import React from "react";
import CareerSkillsSection from "../Shared/CareerSkillsSection";

const CyberCareerSkills = ({ componentData }) => {
  // Parse content into paragraphs (split by double line breaks). Strip the
  // legacy "Discover our…" call-to-action if it appears in CMS content so the
  // section flows cleanly into the new Course Duration / Benefits sections.
  const paragraphs = (componentData?.content
    ? componentData.content.split(/\n\n+/).filter(p => p.trim())
    : [
        "In a world where digital threats are growing every day, Cyber Security professionals are among the most sought-after specialists globally. At JRIIT, our Cyber Security program gives you the technical expertise to protect systems, networks, and data from unauthorized access, attacks, and breaches. You will learn through practical, scenario-based training in ethical hacking, network defense, cryptography, digital forensics, and incident response — preparing you for a career that is both challenging and highly rewarding.",
        "Why JRIIT? We emphasize hands-on learning with real-world security scenarios. You will receive detailed feedback on your security assessments and defensive strategies, giving you a complete understanding of your capabilities.",
      ]
  ).filter((p) => !/^\s*discover our\b/i.test(p));

  const title = componentData?.title || "CYBER-READY SKILLS? CHECK.";

  return (
    <CareerSkillsSection
      title={title}
      paragraphs={paragraphs}
    />
  );
};

export default CyberCareerSkills;
